var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "connection-issues-float connection-issues-indicator align-items-center justify-content-center d-flex"
      },
      [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "div",
            {
              staticClass:
                "connection-issues-wrap mt-0 d-flex align-items-center justify-content-center w-100"
            },
            [
              _c("p", [
                _vm._v(
                  "Cannot fetch location, foreman's device is not connected to internet or is not sending coordinates."
                )
              ])
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-566663ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566663ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobsMapConnectionIssue.vue
// module id = null
// module chunks = 